var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgOrbicIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_768_1963)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M16.3052 10.2806C16.347 9.02976 16.0115 7.7953 15.3423 6.73771C14.6731 5.68013 13.7012 4.84835 12.5529 4.35053C11.4047 3.85272 10.1332 3.71189 8.90385 3.94638C7.6745 4.18086 6.54413 4.7798 5.65974 5.66532C4.77534 6.55084 4.17783 7.68196 3.9449 8.91161C3.71198 10.1413 3.85441 11.4125 4.35368 12.5602C4.85295 13.7078 5.68596 14.6786 6.74439 15.3465C7.80282 16.0143 9.0377 16.3483 10.2885 16.3049",
    stroke: "white",
    strokeWidth: 1.6,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.8438 14.9225C12.8438 15.4739 13.0628 16.0026 13.4526 16.3925C13.8425 16.7823 14.3712 17.0013 14.9225 17.0013C15.4739 17.0013 16.0026 16.7823 16.3925 16.3925C16.7823 16.0026 17.0013 15.4739 17.0013 14.9225C17.0013 14.3712 16.7823 13.8425 16.3925 13.4526C16.0026 13.0628 15.4739 12.8438 14.9225 12.8438C14.3712 12.8438 13.8425 13.0628 13.4526 13.4526C13.0628 13.8425 12.8438 14.3712 12.8438 14.9225Z",
    stroke: "white",
    strokeWidth: 1.6,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_768_1963"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOrbicIcon);
export default __webpack_public_path__ + "static/media/orbic-icon.fe37d24b749b9b2a7173ab17f9fbcf4e.svg";
export { ForwardRef as ReactComponent };